module.exports = __webpack_public_path__ + "media/demo.8c88b123.mp4";